export default __webpack_public_path__ + "static/media/photo--sm--wheel-8.4147cbf5.jpg";